import { inject, Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';

import { CommonApiService } from '../../proxy/services/common-api.service';
import { ListResult, Notification } from '../../proxy/models/common';
import { EntityType } from '../../proxy/models/entity-type.enum';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private commonApiService = inject(CommonApiService);
  private userService = inject(UserService);
  private notificationsSignal = signal<Notification[]>([]);

  public notifications = this.notificationsSignal.asReadonly();

  public getUnreadNotifications(): Observable<ListResult<Notification>> {
    const filters = [{
      property: 'Viewed',
      condition: 'e',
      value: 0,
    }];
    return this.commonApiService.listByOwner<Notification>(
      EntityType.notification,
      this.userService.entityId(),
      EntityType.individual,
      filters
    );
  }

  public getNotifications(): Observable<ListResult<Notification>> {
    return this.commonApiService.listByOwner<Notification>(
      EntityType.notification,
      this.userService.entityId(),
      EntityType.individual,
    );
  }

  public setNotifications(notifications: Notification[]): void {
    this.notificationsSignal.set(notifications);
  }

  public removeNotifications(): void {
    this.notificationsSignal.set([]);
  }

  public deleteNotification(notification: Notification): void {
    this.notificationsSignal.update(current =>
      current.filter(n => n.EntityId !== notification.EntityId)
    );
  }

  public updateNotification(notification: Notification): void {
    this.notificationsSignal.update(current =>
      current.map(item =>
        item.EntityId === notification.EntityId
          ? { ...item, ViewDate: notification.ViewDate }
          : item
      )
    );
  }
}
